const RULES = {
  full_name: { pattern: "(?=.*\\p{L}).{3,80}", maxLength: 80, autoComplete: "name", title: "Nome e cognome (almeno 3 caratteri)" },
  first_name: { pattern: "[\\p{L}][\\p{L}' .\\-]{0,79}", maxLength: 80, autoComplete: "given-name", title: "Solo lettere" },
  last_name: { pattern: "[\\p{L}][\\p{L}' .\\-]{0,79}", maxLength: 80, autoComplete: "family-name", title: "Solo lettere" },
  contact_name: { pattern: "(?=.*\\p{L}).{3,80}", maxLength: 80, title: "Nome e cognome del referente" },
  company: { pattern: "(?=.*\\p{L}).{2,120}", maxLength: 120, autoComplete: "organization", title: "Ragione sociale" },
  address: { pattern: "(?=.*\\p{L}).{5,120}", maxLength: 120, autoComplete: "street-address", title: "Via/piazza e numero civico" },
  city: { pattern: "[\\p{L}][\\p{L}' .\\-\\/]{1,79}", maxLength: 80, autoComplete: "address-level2", title: "Solo lettere" },
  phone: { pattern: "\\+?[0-9 \\(\\)\\.\\/\\-]{6,20}", maxLength: 20, inputMode: "tel", type: "tel", autoComplete: "tel", title: "Numero di telefono, es. +39 333 1234567" },
};

export const fieldRules = (k, country = "Italia") => {
  if (k === "zip") return country === "Italia"
    ? { pattern: "\\d{5}", maxLength: 5, inputMode: "numeric", autoComplete: "postal-code", title: "CAP di 5 cifre" }
    : { pattern: "[A-Za-z0-9][A-Za-z0-9 \\-]{1,9}", maxLength: 10, autoComplete: "postal-code", title: "Codice postale" };
  if (k === "province") return country === "Italia"
    ? { pattern: "[A-Za-z]{2}", maxLength: 2, title: "Sigla di 2 lettere, es. RG", autoComplete: "address-level1" }
    : { maxLength: 40, autoComplete: "address-level1" };
  return RULES[k] || {};
};
